export var RewardExecutionModeEnum;
(function (RewardExecutionModeEnum) {
    RewardExecutionModeEnum["CRON"] = "CRON";
    RewardExecutionModeEnum["EVENT"] = "EVENT";
    RewardExecutionModeEnum["MANUAL"] = "MANUAL";
})(RewardExecutionModeEnum || (RewardExecutionModeEnum = {}));
//# sourceMappingURL=reward-execution-mode.enum.js.map